import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');

// SİHİRLİ KOD: Eğer react-snap daha önceden HTML oluşturmuşsa onun üstüne kon (Hydrate),
// Yoksa (geliştirme aşamasındaysak) normal şekilde sıfırdan çiz (Render).
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  const root = createRoot(container);
  root.render(<App />);
}